import { render } from "./firmaForm.vue?vue&type=template&id=0360e1f2"
import script from "./firmaForm.vue?vue&type=script&lang=js"
export * from "./firmaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__